import styled from 'styled-components';
import { DIMENSION } from './constants';

export const LabelWrapper = styled.div`
  margin-top: 10px;
`;

export const Container = styled.div`
  width: ${DIMENSION}px;
  min-height: 45px;
`;
